<p-dialog [(visible)]="isPeriodicApprovalModal" [style]="{width: '40vw'}" (onHide)="cancel()" [modal]="true">
  <div *ngIf="errorMessages.length > 0">
    <p-messages severity="error">
      <ng-template pTemplate>
        <span class="p-message-icon pi pi-times-circle"></span>
        <span class="p-ml-2">{{errorMessageConstant}} </span>
        <ul>
          <li *ngFor="let errorText of errorMessages">{{ errorText }}</li>
        </ul>
      </ng-template>
    </p-messages>
  </div>
    <ng-template pTemplate="header">
        <b>Periodic Review Approval</b>
    </ng-template>
<div class="field">
    <span>
       {{periodicReviewCRIStaticMessageForModal}}
    </span>
</div>
    <div class="field field-required">
      <bpt-text-input [highlightAllOnFocus]="true" 
      [multiLine]="true" id="approvalDescription" label="Description*" 
      [(ngModel)]="approvalDescription"></bpt-text-input>
    </div>
    <ng-template pTemplate="footer">
        <p-button appPreventDoubleClick label="Confirm" id="confirm" (debounceClick)="confirmPeriodcChangeRequestApproval()"></p-button>
        <p-button appPreventDoubleClick styleClass="p-button-outlined" label="Cancel" id="cancel" (debounceClick)="cancel()"></p-button>
    </ng-template>
</p-dialog>
